import React, { useState } from 'react';
import { OutsideClickHandler } from '../../../../components';
import ProfileIconCard from '../../../../components/ProfileIconCard/ProfileIconCard';
import css from './SelectTopicComponent.module.css';
import { FormattedMessage } from '../../../../util/reactIntl';

const SelectTopicComponent = props => {
    const { spaceTopicsData = {}, setFormOldValues, formOldValues } = props;
    const { records = [] } = spaceTopicsData || {};
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        console.log('first',)
        setIsOpen(prev => !prev);
    };

    const handleTopicSelection = (item) => {
        setIsOpen(false);
        setFormOldValues(prevState => {
            const isAlreadySelected = (prevState.topics || []).includes(item.id);

            const updatedValues = {
                ...prevState,
                topics: isAlreadySelected
                    ? prevState.topics.filter(topicId => topicId !== item.id) // Remove the item
                    : [...(prevState.topics || []), item.id], // Add the item
            };

            return updatedValues;
        });

    }

    const handleRemoveAllTopics = () => {
        setFormOldValues(prevState => ({
            ...prevState,
            topics: [],
        }));
    };

    if (records?.length === 0) {
        return null
    }



    return (
        <OutsideClickHandler className={css.dropdownWrapper} onOutsideClick={() => isOpen && setIsOpen(false)}>
            <div className={css.inputFieldWrapper} onClick={toggleDropdown}>

                <div onClick={toggleDropdown}>

                    {/* <span onClick={toggleDropdown} className={css.iconWrapper}>
                        <ProfileIconCard type="dot" />
                    </span> */}
                    {(isOpen && records?.length > 0) && (
                        <div className={css.dropdownMenu}>
                            <ul>
                                {Array.isArray(records)
                                    ? records?.
                                        filter(item => !formOldValues?.topics?.includes(item.id))?.map((item, index) => <li onClick={() => {
                                            if (formOldValues?.topics.length === 5) return
                                            handleTopicSelection(item)
                                        }} key={index}>{item.name}</li>)
                                    : null}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
            <div className={css.inputBox}>
                <div className={css.dropDownText} onClick={toggleDropdown}>
                    {formOldValues?.topics && formOldValues.topics.length > 0
                        ? formOldValues.topics
                            .map(topicId => (
                                <span
                                    className={css.selectedItem}
                                    key={topicId}
                                    onClick={() => {

                                        handleTopicSelection(records.find(record => record.id === topicId))
                                    }}
                                >
                                    {records.find(record => record.id === topicId)?.name}
                                    <ProfileIconCard type="close" />
                                </span>
                            ))
                        : <label className={css.inputLabel}><FormattedMessage id='CircleCreatePost.topicPlaceHolder' /></label>}
                </div>
                {formOldValues?.topics?.length > 0 ? <div className={css.deleteButton} onClick={handleRemoveAllTopics}><ProfileIconCard type="delete" /></div> : null}
            </div>
        </OutsideClickHandler>
    );
};

export default SelectTopicComponent;
